import React, { Component } from 'react';
import { connect } from 'react-redux';
import { checkEmailChangeValidationLinkIsValid } from '../actions/UserActions';
import { checkBusinessName } from '../../logins/actions/LoginActions';
import { subDomainUrlRedirection } from '../../../actions/utilAction';
import LogoImageViewer from '../../../components/logoImageViewer';
import SmallLoader from '../../../img/small-loader.gif'


class ConfirmationEmailChangeModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
          // errorMessage: null,
          token: props.match.params.token,
        };
    }

    componentWillMount() {
        let subdomain = subDomainUrlRedirection();
        if (subdomain) {
          this.props.checkBusinessName(subdomain);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.businessNameCheck && this.props.businessNameCheck !== prevProps.businessNameCheck) {
          let token = this.props.match.params.token;
          let postData = {
            "token":token
          }
          this.props.checkEmailChangeValidationLinkIsValid(postData, this.props.businessNameCheck);
        }
    }

    renderLoading() {
        return (
            <div className="login_bg">
            <div className="login-wrapper">
                <div className="login-fields">
                Loading...Please wait !
                </div>
            </div>
            </div>
        );
    }
    

    render(){
        let logoUrl = this.props.organizationLogoBase64 && `data:image/png;base64,${this.props.organizationLogoBase64}`;
            
        return(
            <div className="login_bg_WithGradient">
                {this.props.loading ?
                    (<div className="full_loader top0">
                    <div className="small-loader">
                        <img src={SmallLoader} alt="" />
                    </div>
                    </div>) :
                
                (<div className="login-wrapper">
                    <div className="loginlogo">
                        <LogoImageViewer isLoginPage={true} logoUrl={logoUrl} businessName={this.props.businessName} />
                    </div>
                    <div>
                        <div className="login-fields text-center">
                            <div className="resetmail_msg">
                                <div className="pt20">
                                <p>{this.props.message}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>)
              }
            </div>
            
        )
    }

}

function mapStateToProps(state){
    return {
        loading: state.login.loading,
        businessNameCheck: state.login.businessNameCheck,
        organizationLogoBase64: state.login.organizationDetails && state.login.organizationDetails.logoBase64,
        message:state.user.responseMessage,
    }
}

export default connect(mapStateToProps,{checkEmailChangeValidationLinkIsValid, checkBusinessName})(ConfirmationEmailChangeModal);


// WEBPACK FOOTER //
// ./src/modules/users/User/ConfirmationEmailChangeModal.js